import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "/api/v1/admin/wallets";

const Wallets = () => {
    const [wallets, setWallets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [selected, setSelected] = useState(null);
    const [form, setForm] = useState({ user: "", balance: 0, currency: "USD" });

    useEffect(() => { fetchWallets(); }, []);

    const fetchWallets = () => {
        setLoading(true);
        axios.get(API_URL)
            .then(res => setWallets(res.data.wallets || []))
            .finally(() => setLoading(false));
    };

    const handleAdd = () => {
        setSelected(null);
        setForm({ user: "", balance: 0, currency: "USD" });
        setModalOpen(true);
    };

    const handleEdit = (wallet) => {
        setSelected(wallet);
        setForm({ user: wallet.user, balance: wallet.balance, currency: wallet.currency });
        setModalOpen(true);
    };

    const handleDelete = (id) => {
        axios.delete(`${API_URL}/${id}`).then(fetchWallets);
    };

    const handleSubmit = () => {
        setSaving(true);
        if (selected) {
            axios.put(`${API_URL}/${selected._id}`, form).then(() => {
                fetchWallets();
                setModalOpen(false);
            }).finally(() => setSaving(false));
        } else {
            axios.post(API_URL, form).then(() => {
                fetchWallets();
                setModalOpen(false);
            }).finally(() => setSaving(false));
        }
    };

    return (
        <div className="p-4">
            <button
                className="mb-4 px-4 py-2 bg-Pookie-500 text-white rounded hover:bg-Pookie-600 transition"
                onClick={handleAdd}
            >
                Add Wallet
            </button>
            {loading ? (
                <div className="flex justify-center items-center h-40">
                    <div className="w-8 h-8 border-4 border-Pookie-200 border-t-Pookie-500 rounded-full animate-spin" />
                </div>
            ) : (
                <div className="overflow-x-auto bg-white rounded-xl shadow">
                    <table className="min-w-full text-sm">
                        <thead>
                            <tr className="bg-gray-100 text-gray-600 uppercase text-xs">
                                <th className="py-3 px-4 text-left">User</th>
                                <th className="py-3 px-4 text-left">Balance</th>
                                <th className="py-3 px-4 text-left">Currency</th>
                                <th className="py-3 px-4 text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {wallets.map(wallet => (
                                <tr key={wallet._id} className="border-t hover:bg-gray-50">
                                    <td className="py-2 px-4">{typeof wallet.user === 'object' ? wallet.user.fullName : wallet.user}</td>
                                    <td className="py-2 px-4">{wallet.balance}</td>
                                    <td className="py-2 px-4">{wallet.currency}</td>
                                    <td className="py-2 px-4">
                                        <button
                                            className="px-3 py-1 mr-2 bg-Pookie-500 text-white rounded hover:bg-Pookie-600 text-xs"
                                            onClick={() => handleEdit(wallet)}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-xs"
                                            onClick={() => handleDelete(wallet._id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal */}
            {modalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
                        <button
                            className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl"
                            onClick={() => setModalOpen(false)}
                        >
                            &times;
                        </button>
                        <h2 className="text-lg font-bold mb-4 text-Pookie-600">{selected ? "Edit Wallet" : "Add Wallet"}</h2>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium mb-1">User</label>
                                <input
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Pookie-200"
                                    value={form.user}
                                    onChange={e => setForm({ ...form, user: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-1">Balance</label>
                                <input
                                    type="number"
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Pookie-200"
                                    value={form.balance}
                                    onChange={e => setForm({ ...form, balance: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-1">Currency</label>
                                <input
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Pookie-200"
                                    value={form.currency}
                                    onChange={e => setForm({ ...form, currency: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="flex justify-end gap-2 mt-6">
                            <button
                                className="px-4 py-2 bg-Pookie-500 text-white rounded hover:bg-Pookie-600"
                                onClick={handleSubmit}
                                disabled={saving}
                            >
                                {saving ? (selected ? "Saving..." : "Adding...") : (selected ? "Save" : "Add")}
                            </button>
                            <button
                                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                                onClick={() => setModalOpen(false)}
                                disabled={saving}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Wallets; 